/** @file What a notice's offer button runs: Key the unkeyed pose, or a Suggest IK / Auto-rig review. */
import { createT } from '@pose2d/i18n/createT';
import type { DockTarget } from '../../frame/applyLayout';
import { openPanel } from '../../frame/openPanel';
import { catalogs } from '../../shell/i18n/catalogs';
import { settingsStore } from '../../stores/settingsStore';
import { panel as autorigPanel } from '../autorig/Panel';
import { startAutorigReview } from '../autorig/startAutorigReview';
import { viewportApi } from './viewportApi';
import { viewportStore } from './viewportStore';
import type { ViewportNotice } from './viewportTypes';

/** The dock an offer may bring a panel to the front in (the viewport panel's `containerApi`). */
export type OfferDock = DockTarget;

/** Starts the `fn` review and brings the `autorig` tab to the front (re-added when the user closed it), so the panel
 *  mounts and takes the request (W3-70); without a dock the request waits until the panel is opened. */
const review = (fn: string) => (dock?: OfferDock): void => {
  startAutorigReview(fn);
  if (dock !== undefined) openPanel(dock, autorigPanel, createT(catalogs, settingsStore.getState().lang));
};

/** Keyed by ViewportNotice['action']; the Auto-rig hint of a fresh import (N5) is gone once its action ran. */
export const offerActions: Record<Extract<ViewportNotice, { kind: 'offer' }>['action'], (dock?: OfferDock) => void> = {
  key: () => { viewportApi.commitUnkeyed(); },
  suggestIk: review('suggestIk'),
  autoRig: (dock) => { review('autoRig')(dock); viewportStore.setState({ notice: null }); },
};
